import $ from 'jquery';
import _ from 'underscore';

import ch_collection from 'collections/coachhub';
import domainModel from 'models/domain';


export default ch_collection.extend({
  url: DOMAINS_API_URL,
  model: domainModel,
  pretty_print: function (code) {
    return this.findWhere({ slug: code }).escape('name');
  }

});



// WEBPACK FOOTER //
// ./static/js/collections/domains.js